import { createSelector } from 'reselect'
import { selectMailboxesIncludingInaccessible } from './selectMailboxesIncludingInaccessible'
import { CHANNEL_STATE } from '../constants'

export const selectDemoMailboxId = createSelector(
  selectMailboxesIncludingInaccessible,
  mailboxes => (mailboxes || []).find(m => m?.state === CHANNEL_STATE.DEMO)?.id
)
